import { Navigate, useRoutes, Outlet } from 'react-router-dom';
// config
import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { mainRoutes, HomePage } from './main';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import CompactLayout from '../../layouts/compact';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    {
      path: '/',
      element: (
        <CompactLayout>
          <Outlet />
        </CompactLayout>
      ),
      children: [{ element: <HomePage />, index: true }],
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
